import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Stores from './Components/Stores';
import ProductCategoryPage from './Components/ProductCategoryPage';
import CareerForm from './Components/CareerForm';
import BrandProducts from './Components/BrandProducts';
import ProductDetails from './Components/ProductDetails.js';
import Cart from './Components/Cart.js';
import Cart_page from './Components/Cart_page.js';
import ComparePage from './Components/Compare_page.js';
import RegisterLoginpage from './Components/Register_Login_page.js';
import MyAccount from './Components/My_account.js';
import Orders from './Components/orders.js';
import Address from './Components/Address.js';
import EditBillingAddressForm from './Components/Edit_billing_address.js';
import EditShippingAddressForm from './Components/Edit_shipping_address.js';
import AccountDetails from './Components/Account_details.js';
import SingleOrderDetails from './Components/Single_order_page.js';
import Checkout from './Components/Checkout.js';
import CheckoutPage from './Components/Checkout_page.js';
import ContactForm from './Components/ContactForm.js';
import CategoryModelPage from './Components/Category_model_page.js';
import BrandProductPage from './Components/Brand_product_page.js';
import SearchPage from './Components/Search_page.js';
import Store from './Components/Stores_page.js';
import TermsAndConditions from './Components/TermsAndConditions.js';
import PrivacyPolicy from './Components/PrivacyPolicy.js';
import About from './Components/About.js';
import PaymentReturnPolicies from './Components/PaymentReturnPolicies.js';
import ShippingOptions from './Components/ShippingOptions.js';
import WishlistPage from './Components/Wishlist_page.js';
import PaymentSuccess from './Components/payment-success.js';
import PaymentFailure from './Components/payment-failure.js';
import { PaymentProvider } from './Components/context.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PaymentProvider>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/failure" element={<PaymentFailure />} />
        {/* <Route path="/category/:category" element={<ProductCategoryPage />} /> */}
        <Route path="/category/:category" element={<CategoryModelPage />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/store-locator" element={<Store />} />
        <Route path="/career" element={<CareerForm></CareerForm>} />
        {/* <Route path="/brands/:brandName" element={<BrandProducts></BrandProducts>}/> */}
        <Route path="/brands/:brandName" element={<BrandProductPage />} />
        <Route path="/cart" element={<Cart_page />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/register-login" element={<RegisterLoginpage />} />
        <Route path='/my-account' element={<MyAccount />}>
          <Route path='orders' element={<Orders />} />
          <Route path='address' element={<Address />} />
          <Route path='edit-billing-address' element={<EditBillingAddressForm />} />
          <Route path='edit-shipping-address' element={<EditShippingAddressForm />} />
          <Route path='account-details' element={<AccountDetails />} />
          <Route path='order-details/:orderId' element={<SingleOrderDetails />} />
        </Route>
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path='/contact-us' element={<ContactForm />} />
        <Route path='/search/:search' element={<SearchPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/about-us' element={<About />} />
        <Route path='/payment-return-policies' element={<PaymentReturnPolicies />} />
        <Route path='/shipping-options' element={<ShippingOptions />} />
        <Route path='/wishlist' element={<WishlistPage />} />
      </Routes>
    </Router>
  </PaymentProvider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
